import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "../../common/services/base-http-service";
import { environment } from "../../../environments/environment";
import { from, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { TokenService } from "../../common/services/token.service";
import { AccountStorageResetService } from '../../common/services/account-storage-reset.service';

@Injectable({
    providedIn: 'root',
  })
  export class LoginService extends BaseHttpService {
    baseUrl: string = `${environment.baseUrl}`; // already includes /api/v1

    constructor(
      http: HttpClient,
      tokenService: TokenService,
      private readonly accountStorageReset: AccountStorageResetService,
    ) {
      super(http, tokenService);
    }

    // Request OTP code for a phone number
    requestOtp(phone: string): Observable<any> {
      return this.http.post(`${this.baseUrl}/auth/otp`, { phone });
    }

    // Login with phone + otp; store tokens on success
    login(phone: string, otp: string): Observable<any> {
      return this.http.post(`${this.baseUrl}/auth/login`, { phone, otp }).pipe(
        switchMap((res: any) => this.startFreshSession(res)),
      );
    }

    // Login with phone + password for panel users; store tokens on success
    loginWithPassword(phone: string, password: string): Observable<any> {
      return this.http.post(`${this.baseUrl}/auth/login/panel`, { phone, password }).pipe(
        switchMap((res: any) => this.startFreshSession(res)),
      );
    }

    // Refresh access token using refresh token
    refresh(refreshToken: string): Observable<any> {
      return this.http.post(`${this.baseUrl}/auth/refresh`, { refreshToken });
    }

    private startFreshSession(res: any): Observable<any> {
      return from(this.accountStorageReset.resetAccountData()).pipe(
        map(() => {
          this.persistAuthSession(res);
          return res;
        }),
      );
    }

    private persistAuthSession(res: any): void {
      const data = res?.data || res;
      const accessToken = data?.accessToken || data?.access_token || data?.token;
      const refreshToken = data?.refreshToken || data?.refresh_token;
      const user = data?.user || data?.profile;

      if (accessToken) {
        this.tokenService.setTokens(accessToken, refreshToken);
      }

      if (user) {
        this.tokenService.setUser(user);
      }
    }
  }
